<template>
  <div class="category-input" v-on="$listeners">
    <div v-if="!value && placeholder" class="category-input__placeholder">{{ placeholder }}</div>
    <div v-for="(item, index) in items" :key="index" class="category-input__item">
      <FontAwesomeIcon v-if="index" :icon="['fal', 'angle-right']" size="lg" />
      <div>{{ item }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    seperator: {
      type: String,
      default: '/',
    },
    placeholder: {
      type: String,
      default() {
        return this.$t('select') + '...'
      },
    },
  },
  computed: {
    items() {
      if (!this.value) return []
      return this.value.split(this.seperator)
    },
  },
}
</script>

<style lang="scss">
.category-input {
  $gap: 0.5rem;
  display: flex;
  gap: $gap;
  overflow-x: auto;
  cursor: pointer;

  &__placeholder {
    opacity: 0.75;
  }

  &__item {
    display: flex;
    align-items: center;
    white-space: nowrap;

    svg {
      opacity: 0.3;
      margin-right: $gap;
    }
  }
}
</style>
